(() => {
  if (window.__rtcgRecommendationAnalyticsInitialized) return;
  window.__rtcgRecommendationAnalyticsInitialized = true;

  const seen = new WeakSet();

  const payloadFor = (item, action = '') => ({
    surface: item.dataset.rtcgRecommendationSurface || '',
    intent: item.dataset.rtcgRecommendationIntent || '',
    source: item.dataset.rtcgRecommendationSource || '',
    sourceProductId: item.dataset.rtcgSourceProductId || '',
    recommendedProductId: item.dataset.rtcgRecommendedProductId || item.dataset.productId || '',
    rank: Number(item.dataset.rtcgRecommendationRank || 0),
    action,
  });

  const emit = (name, item, action = '') => {
    if (!item) return;
    document.dispatchEvent(
      new CustomEvent(`raretcg:recommendation-${name}`, {
        detail: payloadFor(item, action),
      }),
    );
  };

  const observe = (item) => {
    if (seen.has(item)) return;
    seen.add(item);

    if (!('IntersectionObserver' in window)) {
      emit('impression', item);
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries.some((entry) => entry.isIntersecting && entry.intersectionRatio >= 0.35)) {
          emit('impression', item);
          observer.disconnect();
        }
      },
      { threshold: [0.35] },
    );
    observer.observe(item);
  };

  const scan = (root = document) => {
    root.querySelectorAll?.('[data-rtcg-recommendation-item]').forEach(observe);
  };

  document.addEventListener('click', (event) => {
    const target = event.target.closest('a, button');
    if (!target) return;
    const item = target.closest('[data-rtcg-recommendation-item]');
    if (!item) return;

    const isAdd = Boolean(
      target.matches('[data-rtcg-cart-add], [name="add"]') ||
      target.closest('product-form') ||
      target.closest('[data-rtcg-cart-add]'),
    );

    emit('click', item, isAdd ? 'add_to_cart' : 'open_product');
    if (isAdd) emit('add-intent', item, 'add_to_cart');
  });

  const mutationObserver = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (!(node instanceof Element)) continue;
        if (node.matches?.('[data-rtcg-recommendation-item]')) observe(node);
        scan(node);
      }
    }
  });

  const start = () => {
    scan();
    mutationObserver.observe(document.documentElement, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
